import { FC, useState } from "react";
import { uploadFile } from "data/adminApi";
import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";

interface Props {
  folder?:
    | "product_images"
    | "product_pdfs"
    | "clients"
    | "projects"
    | "categories";
  accept?: string;
  label?: string;
  onUploaded: (url: string) => void;
}

const FileUploader: FC<Props> = ({
  folder = "product_images",
  accept = "image/*",
  label = "Upload file",
  onUploaded,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    setError("");
    try {
      const res = await uploadFile(file, folder);
      onUploaded(res.url);
    } catch (err: any) {
      setError(
        err?.response?.data?.detail || "Upload failed. Please try again."
      );
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <label className="inline-flex items-center gap-2 h-10 px-4 rounded-xl border border-dashed border-neutral-300 dark:border-neutral-600 bg-neutral-50 dark:bg-neutral-800 text-sm font-medium cursor-pointer hover:border-primary-400 transition-colors">
        <ArrowUpTrayIcon className="w-4 h-4" />
        {loading ? "Uploading…" : label}
        <input
          type="file"
          accept={accept}
          className="sr-only"
          disabled={loading}
          onChange={handleChange}
        />
      </label>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default FileUploader;
